import { useMap } from "@vis.gl/react-google-maps";
import { memo, useEffect } from "react";
const MapHandler = ({ place }) => {
    const map = useMap();
    useEffect(() => {
        var _a;
        if (!map || !place)
            return;
        if ((_a = place.geometry) === null || _a === void 0 ? void 0 : _a.viewport) {
            map.fitBounds(place.geometry.viewport);
        }
    }, [map, place]);
    return null;
};
export default memo(MapHandler);
